import React from "react";
import CompaniesListComponent from "../../components/CompaniesList/CompaniesList.component";
import "./Companies.css";
const ContractsContainer = (props) => {
  return (
    <React.Fragment>
      <div className="page-header">Administration</div>
      <div className="companies-list">
        <CompaniesListComponent {...props}></CompaniesListComponent>
      </div>
    </React.Fragment>
  );
};

export default ContractsContainer;
